<template>
  <!-- 房产 -->
  <div class="house">
    <el-card class="box-card">
      <div class="filter-container">
        <div>
          <i class="el-icon-search"></i>
          <span>筛选搜索</span>
        </div>
        <div style="margin-top: 15px">
          <el-form :inline="true" label-width="120px" size="small">
            <el-form-item label="楼盘名字">
              <el-input
                placeholder="请输入内容"
                v-model="searchData.floorName"
                clearable
              ></el-input>
            </el-form-item>
            <el-form-item label="开发商名字">
              <el-input
                placeholder="请输入内容"
                v-model="searchData.kaifashangName"
                clearable
              ></el-input>
            </el-form-item>
            <el-form-item label="销售状态">
              <el-select
                v-model="searchData.xiaoshouId"
                placeholder="请选择"
                clearable
              >
                <el-option
                  v-for="item in xiaotai"
                  :key="item.value"
                  :label="item.name"
                  :value="item.enumeration"
                ></el-option>
              </el-select>
            </el-form-item>

            <el-form-item label="推荐猜你喜欢" style="marginleft: 28px">
              <el-radio-group v-model="searchData.isLike" clearable>
                <el-radio :label="0" value="0">不推荐</el-radio>
                <el-radio :label="1" value="1">推荐</el-radio>
              </el-radio-group>
            </el-form-item>
            <el-form-item label="热门房产" style="marginleft: 28px">
              <el-radio-group v-model="searchData.isHot" clearable>
                <el-radio :label="0" value="0">否</el-radio>
                <el-radio :label="1" value="1">是</el-radio>
              </el-radio-group>
            </el-form-item>

            <div>
              <el-form-item>
                <el-button
                  size="mini"
                  style="float: right; margin-left: 90px"
                  type="primary"
                  @click="handleSearch"
                  v-if="menuPerm('newfloor:list')"
                  >查询</el-button
                >
              </el-form-item>

              <el-form-item>
                <el-button
                  class="filter-item"
                  icon="el-icon-edit"
                  size="mini"
                  style="float: right; flex: auto; margin-left: 30px"
                  type="primary"
                  @click="handleAdd"
                  v-if="menuPerm('newfloor:insert')"
                  >新增楼盘</el-button
                >
              </el-form-item>

              <el-form-item>
                <el-button
                  class="filter-item"
                  size="mini"
                  style="float: right; flex: auto; margin-left: 30px"
                  type="primary"
                  @click="handleClear"
                  >清空</el-button
                >
              </el-form-item>
            </div>
          </el-form>
        </div>
      </div>
    </el-card>
    <!-- 数据 -->
    <!-- list.slice((currentPage-1)*pagesize,currentPage*pagesize) -->
    <el-card style="width: 95%; margin: 20px auto">
      <el-table
        border
        ref="multipleTable"
        style="width: 100%; flex: auto"
        tooltip-effect="light"
        :data="listData"
        @selection-change="handleSelectionChange"
        :header-cell-style="getRowClass"
      >
        <!-- 多选-->
        <el-table-column label="楼盘名字" prop="name"></el-table-column>
        <el-table-column label="开发商名字" prop="kaifashang"></el-table-column>

        <el-table-column label="销售状态" prop="xiaoshouId" width="80px">
          <!--  -->
          <template slot-scope="{ row }">
            <div v-for="(item, index) in xiaotai" :key="index">
              <span v-if="item.enumeration == row.xiaoshouId">{{
                item.name
              }}</span>
            </div>
          </template>
        </el-table-column>
        <el-table-column label="海报" prop="posterUrl" width="80px">
          <template slot-scope="{ row }">
              <img :src="row.posterUrl" :preview="row.id" alt="" style="height: 50px" />
          </template>
        </el-table-column>
        <el-table-column
          align="center"
          class-name="small-padding fixed-width"
          label="操作"
        >
          <template slot-scope="{ row, $index }">
            <el-button
              type="primary"
              @click="handleDetail(row.id, $index)"
              style="
                background-color: #409eff;
                color: #fff;
                border-color: #409eff;
              "
              v-if="menuPerm('newfloor:list')"
              size="mini"
              >详情</el-button
            >
            <el-button
              size="mini"
              style="width: 60px; margin: 0 0 10px 10px"
              type="success"
              v-if="row.deleteStatus == 0"
              @click="shelves(row, 1)"
              >上线</el-button
            >

            <el-button
              size="mini"
              style="width: 60px; margin: 0 0 10px 10px"
              type="warning"
              @click="shelves(row, 0)"
              v-if="row.deleteStatus == 1"
              >下线</el-button
            >
            <el-button
              size="mini"
              style=""
              type="primary"
              @click="posterBtn(row.id)"
              >生成海报</el-button
            >
          </template>
        </el-table-column>
      </el-table>
      <el-row style="width: auto; marginright: 50px; margintop: 20px">
        <el-pagination
          :current-page="currentPage"
          :page-size="pagesize"
          :page-sizes="[5, 10, 15]"
          :total="totalCount"
          @current-change="handleCurrentChange"
          @size-change="handleSizeChange"
        ></el-pagination>
      </el-row>
    </el-card>

    <!-- 详情页面 -->
    <a-drawer
      title="楼盘详情"
      :width="1300"
      :visible="visible"
      :body-style="{ paddingBottom: '80px' }"
      @close="onClose"
    >
      <Detail :Detaildata="detailId" />
    </a-drawer>
  </div>
</template>
<script>
import Detail from "./detail";
export default {
  data() {
    return {
      detailId: "",
      visible: false,
      currentPage: 1, //初始页
      pagesize: 10, //每页数据
      totalCount: 0, //分页数量展示
      listData: [], //房产列表数据
      searchData: {
        floorName: "", //楼盘名字
        kaifashangName: "", //开发商名字
        xiaoshouId: "", //销售状态
        isLike: "", //是否推荐猜你喜欢 0不推荐 1推荐
        isHot: "", //热门房产
      },
      xiaotai: "", //销售状态（字典表）【下拉框】
    };
  },
  components: {
    Detail,
  },
  methods: {
    onClose() {
      this.visible = false;
    },
    //头部样式
    getRowClass({ row, column, rowIndex, columnIndex }) {
      if (rowIndex === 0) {
        return "background-color: #f5f7fa;color:#000;width:100%";
      } else {
        return "";
      }
    },
    // 上线下线
    shelves(row, val) {
      this.getAxios("/newfloor/standAndDown", {
        id: row.id,
        status: val,
      }).then((res) => {
        if (res.success) {
          this.$message.success(res.message);
          this.init();
        } else {
          this.$message.error(res.message);
        }
      });
    },
    // 生成海报
    posterBtn(id) {
      this.getAxios("/newfloor/generate/poster", {
        id: id,
      }).then((res) => {
        if (res.success == true) {
          this.$message.success(res.message);
        } else {
          this.$message.error(res.message);
        }
      });
    },
    //获取
    init() {
      this.postAxios("/newfloor/list", {
        pageNum: this.currentPage,
        pageSize: 10,
      }).then((res) => {
        if (res.success == true) {
          this.listData = res.content;
          this.totalCount = res.totalCount;
        } else if (!res.success && res.statusCode == "401") {
          this.$message.error(res.message);
          this.$router.push("/");
        } else if (res.success == false) {
          this.$message.error(res.message);
        }
      });
    },
    //跳转详情
    handleDetail(ids, ind) {
      // this.$router.push({ path: "/houseDetail", query: { id: ids } });
      this.visible = true;
      this.detailId = ids;
    },
    //跳转新增
    handleAdd() {
      this.$router.push({ path: "/houseAdd" });
    },
    //清空
    handleClear() {
      this.searchData = {};
    },
    //销售状态（字典表）【下拉框】
    handleXiao() {
      this.getAxios(`/dic/list/xiaoshoustatus`, {}).then((res) => {
        if (res.success == true) {
          this.xiaotai = res.content;
        } else if (!res.success && res.statusCode == "401") {
          this.$message.error(res.message);
          this.$router.push("/");
        } else if (res.success == false) {
          this.$message.error(res.message);
        }
      });
    },
    //列表查询
    handleSearch() {
      this.currentPage = 1;
      this.postAxios("/newfloor/list", {
        floorName: this.searchData.floorName, //楼盘名字
        kaifashangName: this.searchData.kaifashangName, //开发商名字
        xiaoshouId: this.searchData.xiaoshouId, //销售状态
        isLike: this.searchData.isLike, //是否推荐猜你喜欢 0不推荐 1推荐
        isHot: this.searchData.isHot, //热门房产
        pageNum: "1",
        pageSize: "10",
      }).then((res) => {
        if (res.success == true) {
          this.listData = res.content;
          this.totalCount = res.totalCount;
        } else if (!res.success && res.statusCode == "401") {
          this.$message.error(res.message);
          this.$router.push("/");
        } else if (res.success == false) {
          this.$message.error(res.message);
        }
      });
    },
    //分页
    handleCurrentChange: function (currentPage) {
      this.currentPage = currentPage;
      this.init();
      // console.log(this.currentPage); //点击第几页
    },
    handleSizeChange: function (size) {
      this.pagesize = size;
      this.init();
      // console.log(this.pagesize); //每页下拉显示数据
    },
    handleSelectionChange(val) {
      this.multipleSelection = val;
    },
  },
  created() {
    this.init();
    //销售状态（字典表）【下拉框】

    // alert(process.env.NODE_ENV)
  },
  mounted() {
    this.handleXiao();
  },
};
</script>
<style scoped lang="less">
.house {
  //   width:auto;
  //   height: 100%;
  .box-card {
    width: 95%;
    margin: 0 auto;
    margin-top: 30px;
    .filter-container {
      height: auto;
    }
    /deep/ .el-button--primary {
      color: #fff;
      background-color: #409eff;
      border-color: #409eff;
      width: 100px;
      margin-top: 10px;
      margin-left: 10px;
    }
  }
}
</style>
